module.exports = __webpack_public_path__ + "img/Monte_Kope_27.bb1507c8.jpg";